module.exports = __webpack_public_path__ + "img/icon-arrow-right-disabled.18521267.svg";